export enum IncomingActions {
    Loaded = 'LOADED',
    ROUTING = 'ROUTING',
    LOGOUT = 'LOGOUT',
    CLOSE_SLOT = 'CLOSE_SLOT',
}
